import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { AuthGate } from './components/layout/AuthGate';
import { Sidebar } from './components/layout/Sidebar';
import { ProjectsPage } from './components/projects/ProjectsPage';
import { ProjectDetail } from './components/projects/ProjectDetail';
import { MonitoringPage } from './components/monitoring/MonitoringPage';
import { AlertsPage } from './components/alerts/AlertsPage';
function App() {
    const [activePage, setActivePage] = useState('projects');
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const handleNavigate = (page) => {
        setActivePage(page);
        setSelectedProjectId(null);
    };
    return (_jsx(AuthGate, { children: ({ user, logout }) => (_jsxs("div", { className: "flex h-screen bg-gray-50", children: [_jsx(Sidebar, { activePage: activePage, onNavigate: handleNavigate, user: user, onLogout: logout }), _jsxs("main", { className: "flex-1 overflow-auto pt-16 md:pt-0", children: [activePage === 'projects' && !selectedProjectId && (_jsx(ProjectsPage, { onProjectSelect: (id) => setSelectedProjectId(id) })), activePage === 'projects' && selectedProjectId && (_jsx(ProjectDetail, { projectId: selectedProjectId, onBack: () => setSelectedProjectId(null) })), activePage === 'monitoring' && _jsx(MonitoringPage, {}), activePage === 'alerts' && _jsx(AlertsPage, {})] })] })) }));
}
export default App;
